import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5ab962f1&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=5ab962f1&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab962f1",
  null
  
)

export default component.exports